import { IResponse } from "models";

export enum ActionType {
  GET_CONSULTATION_LIST = "action/GET_CONSULTATION_LIST",
  GET_CONSULTATION_LIST_SUCCESS = "action/GET_CONSULTATION_LIST_SUCCESS",
  GET_CONSULTATION_LIST_ERROR = "action/GET_CONSULTATION_LIST_ERROR",
  GET_CONSULTATION_LIST_RESET = "action/GET_CONSULTATION_LIST_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface ConsultationsPayload {
  page: number;
  per_page: number;
  from_date: string;
  to_date: string;
}

export interface IDoctorResponse {
  comment: string;
  diagnosis_comment: string;
  diagnosis_title: string;
  end_greeting: string;
  medical_instruction_comment: string;
  medical_instruction_title: string;
  medicine_comment: string;
  medicines_count_positive: any;
  medicines_name: string;
  start_greeting: string;
}

export interface IConsultData {
  id: number;
  consultation_created_at: string;
  disease_name: string;
  doctor_name: string;
  doctor_response_created_at: string;
  doctor_response: IDoctorResponse;
}

export interface IConsultationListResponse extends IResponse {
  result: IConsultData[];
  total_record: number;
  total_not_cancel: number;
}
